module.exports = "https://cdn.realtymogul.com/static/media/icon_clock.038ad609.svg";